module.exports = __webpack_public_path__ + "img/ameron@2x.5391db7.png";